import { c as _c } from "react/compiler-runtime";
import { UserIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { CgClose, CgMenuRightAlt } from 'react-icons/cg';
import logoImage from '@/public/images/logo.svg';
import i18n from '@/src/i18n';
import { goToPartnerPage, sendAnalyticsData } from '@/src/utils/analytics';
import { dashboardUrl } from '@/src/utils/processenv';
import { ChooseLang } from '../ChooseLang';
import { DropDownMenu } from '../DropDownMenu';
interface IProps {
  displayShadow: boolean;
  ribbonVisible: boolean;
}
export const Header = t0 => {
  const $ = _c(40);
  const {
    displayShadow,
    ribbonVisible
  } = t0;
  const signupUrl = `${dashboardUrl}/signup`;
  const loginUrl = `${dashboardUrl}/signin`;
  const path = usePathname();
  const Links = [{
    name: "Features",
    link: "/features/",
    subMenu: [{
      name: "All Features",
      link: "/features/"
    }, {
      name: "AbleSpace AI",
      link: "/features/ablespace-ai/"
    }, {
      name: "IEP Audit",
      link: "/features/iep-audit/"
    }, {
      name: "Data Types",
      link: "/features/data-types/"
    }, {
      name: "Service Time",
      link: "/features/service-time/"
    }, {
      name: "Accommodations",
      link: "/features/accommodations/"
    }, {
      name: "Custom Goals",
      link: "/features/custom-goals/"
    }, {
      name: "Rotating Schedule",
      link: "/features/rotating-schedule/"
    }]
  }, {
    name: "Support",
    link: "/support/",
    subMenu: [{
      name: "FAQ",
      link: "/faqs/"
    }, {
      name: "Reviews",
      link: "/reviews/"
    }]
  }, {
    name: "Schools/Districts",
    link: "/schools-and-districts/"
  }, {
    name: "Tutorials",
    link: "/tutorials/"
  }, {
    name: "Learn",
    link: "/learn/",
    subMenu: [{
      name: "Blog",
      link: "/blog/"
    }, {
      name: "Tutorials",
      link: "/tutorials/"
    }, {
      name: "Courses",
      link: "/learn/courses/"
    }, {
      name: "Webinars",
      link: "/learn/webinars/"
    }, {
      name: "Research",
      link: "/research/"
    }]
  }, {
    name: "Plans",
    link: "/pricing/"
  }];
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  const t1 = `fixed left-0 z-50 w-full bg-white transition-[top] duration-200 ${displayShadow ? "shadow-md" : ""}`;
  const t2 = ribbonVisible ? "44px" : "0";
  let t3;
  if ($[0] !== t2) {
    t3 = {
      top: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = "container mx-auto lg:p-4 xl:px-10";
  const t5 = "flex items-center gap-6";
  let t6;
  if ($[2] !== open) {
    t6 = () => setOpen(!open);
    $[2] = open;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image className="h-7 w-7 cursor-pointer md:h-[40px] md:w-[40px]" src={logoImage} alt="Logo" />;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t6) {
    t8 = <Link href="/"><span onClick={t6}>{t7}</span></Link>;
    $[5] = t6;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== open || $[8] !== path) {
    t9 = path === "/tutorials/" && !open && <span className="mr-2 lg:hidden" aria-label="Choose Language"><ChooseLang isHeader={true} /></span>;
    $[7] = open;
    $[8] = path;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== open) {
    t10 = () => setOpen(!open);
    $[10] = open;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = open ? "Close menu" : "Open menu";
  let t12;
  if ($[12] !== open) {
    t12 = open ? <CgClose size={32} color="#4E4E4E" /> : <CgMenuRightAlt size={32} color="#4E4E4E" />;
    $[12] = open;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t10 || $[15] !== t11 || $[16] !== t12) {
    t13 = <button onClick={t10} className="lg:hidden" aria-label={t11}>{t12}</button>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13 || $[19] !== t9) {
    t14 = <div className="mr-2">{t9}{t13}</div>;
    $[18] = t13;
    $[19] = t9;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14 || $[22] !== t8) {
    t15 = <div className="relative z-10 flex h-full w-full items-center justify-between bg-white px-6 py-5 lg:w-fit lg:p-0">{t8}{t14}</div>;
    $[21] = t14;
    $[22] = t8;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  const t16 = `${open ? "top-0" : "top-[-2000px] lg:top-0"} fixed left-0 mt-16 h-screen w-full items-center justify-between bg-white px-8 pt-3 duration-500 md:px-32 md:pt-6 lg:relative lg:mt-0 lg:flex lg:h-fit lg:px-0 lg:pt-0`;
  const t17 = "flex flex-col gap-1 lg:flex-row lg:flex-wrap lg:justify-center";
  const t18 = Links.map(link => <li key={link.name}>{link.subMenu ? <DropDownMenu sunMenu={link.subMenu} linkName={link.name} closeMenu={() => setOpen(!open)} /> : <Link href={link.link} className="flex px-3 py-2 lg:items-center lg:justify-center" onClick={() => {
      setOpen(!open);
      sendAnalyticsData(`HEADER_MENU_${link.name.replace(" ", "_").toUpperCase()}_CLICKED`, {
        tab: link.name
      });
    }}><span className={`block bg-white ${pathname === link.link ? "text-[#318AE5]" : "text-[#404040] duration-150 hover:text-[#318AE5]"}`}>{i18n.t(link.name)}</span></Link>}</li>);
  let t19;
  if ($[24] !== t18) {
    t19 = <ul className={t17}>{t18}</ul>;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = () => {
      sendAnalyticsData("LOG_IN_BUTTON_CLICKED");
      goToPartnerPage(loginUrl);
    };
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <UserIcon className="mr-1.5 h-6 w-6" />;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <button className="px-3 py-3.5 font-semibold text-[#318AE5]" onClick={t20}><span className="flex items-center">{t21}<span className="text-base font-medium">{i18n.t("Log In")}</span></span></button>;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="mt-6 flex items-center gap-4 lg:mt-0 lg:flex-row">{t22}<button className="rounded-lg border-2 border-[#318AE5] bg-[#318AE5] px-5 py-2.5 font-semibold text-white duration-150 hover:opacity-90" onClick={() => {
        sendAnalyticsData("SIGN_UP_BUTTON_CLICKED");
        goToPartnerPage(signupUrl);
      }}>{i18n.t("Start for FREE!")}</button></div>;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] !== t16 || $[31] !== t19) {
    t24 = <div className={t16}>{t19}{t23}</div>;
    $[30] = t16;
    $[31] = t19;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  let t25;
  if ($[33] !== t15 || $[34] !== t24) {
    t25 = <div className={t4}><div className={t5}>{t15}{t24}</div></div>;
    $[33] = t15;
    $[34] = t24;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  let t26;
  if ($[36] !== t1 || $[37] !== t25 || $[38] !== t3) {
    t26 = <div className={t1} style={t3}>{t25}</div>;
    $[36] = t1;
    $[37] = t25;
    $[38] = t3;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  return t26;
};